import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4b5ec74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=f4b5ec74&prod&lang=less&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=f4b5ec74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b5ec74",
  null
  
)

export default component.exports